import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { HttpModule } from '@angular/http';
import { MdlModule } from '@angular-mdl/core';
import { FormsModule } from '@angular/forms';

import { HeaderNavModule } from '../../../../shared/components/header-nav/header-nav.module';
import { MenubarModule } from '../../../../shared/components/menubar/menubar.module';
import { SettingsMenuModule } from '../settings-menu/settings-menu.module';
import { TranslateModule } from '../../../../translate/translate.module';

import { ChangePasswordComponent } from './change-password.component';

@NgModule({
  imports: [
    CommonModule,
    MdlModule,
    HttpModule,
    FormsModule,
    HeaderNavModule,
    MenubarModule,
    SettingsMenuModule,
    TranslateModule
  ],
  declarations: [
    ChangePasswordComponent
  ],
  exports: [ChangePasswordComponent]
})
export class ChangePasswordModule { }
